import { render, staticRenderFns } from "./ResumoAlertas.vue?vue&type=template&id=035f221f&scoped=true&lang=pug"
import script from "./ResumoAlertas.vue?vue&type=script&lang=js"
export * from "./ResumoAlertas.vue?vue&type=script&lang=js"
import style0 from "./ResumoAlertas.vue?vue&type=style&index=0&id=035f221f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f221f",
  null
  
)

export default component.exports